import { findByLabelText } from "@testing-library/react";
import React from "react";
import { useRef, useContext } from "react";
import AppContext from "../context/AppProvider";
import { DEFAULT_COLOR } from "../lib/constants";

const AddHabit = ({ newHabit, setNewHabit, handleSubmit }) => {
  const { settings } = useContext(AppContext);

  const style = {
    margin: "10%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  const buttonStyle = {
    margin: "4%",
    height: "5vh",
    width: "50%",
    backgroundColor: settings?.color || DEFAULT_COLOR,
    color: "white",
    borderRadius: "50px",
    border: "0px",
    boxShadow: "1px 2px #888888",
    fontSize: "1.4rem",
  };

  const enterHabitStyle = {
    width: "70%",
    borderRadius: "12px",
    height: "3vh",
    marginBottom: "2vh",
    fontSize: "1.4rem",
  };

  const inputRef = useRef();

  return (
    <form style={style} onSubmit={handleSubmit}>
      <label
        style={{ position: "absolute", left: "-99999px" }}
        htmlFor="addHabit"
      >
        Add Habit
      </label>
      <input
        autoFocus
        style={enterHabitStyle}
        id="addHabit"
        ref={inputRef}
        type="text"
        placeholder="Enter Habit"
        required
        value={newHabit}
        onChange={(e) => {
          setNewHabit(e.target.value);
        }}
      />
      <button
        style={buttonStyle}
        type="submit"
        aria-label="Add Habit"
        onClick={() => inputRef.focus()}
      >
        Add
      </button>
    </form>
  );
};

export default AddHabit;
